import { IUserControlControl } from '@se/cp.common';
import { DataBinding } from '@se/se.ui.html5';

import { CpControl } from './cp-control';

export class CpUserControl extends CpControl {
    readonly controlTypeGroup = 'UserControl';
    readonly idUserControl: string;
    readonly parameters: any;
    readonly dataBindingContext?: DataBinding;

    constructor(control: IUserControlControl, dataBindingContext?: DataBinding) {
        super(control);

        this.dataBindingContext = dataBindingContext;
        this.idUserControl = control.config[0]?.id;
        this.parameters = control.config[0]?.parameters;
    }

    canAlignToBottom() {
        return false;
    }

    getHeightHint() {
        return 0;
    }
}
